import {Dashboard} from '../../Services/DashboardService';
import {Page} from '../../Models';
import {Article} from '../../Services/ArticleService';
import {Author} from '../../Services/AuthorService';
import {Survey} from '../../Services/SurveyService';
import {Metric} from '../../Services/MetricService';
import {Exception} from '../../Services/ExceptionService';

export const SET_DASHBOARD = 'admin/SET_DASHBOARD';
export const SET_PAGE = 'admin/SET_PAGE';
export const SET_ARTICLES = 'admin/SET_ARTICLES';
export const SET_ARTICLE = 'admin/SET_ARTICLE';
export const SET_AUTHORS = 'admin/SET_AUTHORS';
export const SET_CATEGORIES = 'admin/SET_CATEGORIES';
export const SET_SURVEYS = 'admin/SET_SURVEYS';
export const SET_SURVEY = 'admin/SET_SURVEY';
export const SET_METRICS = 'admin/SET_METRICS';
export const SET_METRIC = 'admin/SET_METRIC';
export const SET_EXCEPTIONS = 'admin/SET_EXCEPTIONS';
export const SET_EXCEPTION = 'admin/SET_EXCEPTION';

export type ModuleType = 'articles' | 'authors' | 'categories' | 'surveys' | 'metrics' | 'exceptions';

interface SetDashboardAction {
  type: typeof SET_DASHBOARD;
  payload: Dashboard;
}

interface SetPageAction {
  type: typeof SET_PAGE;
  payload: {
    module: ModuleType;
    page: number;
  };
}

interface SetArticlesAction {
  type: typeof SET_ARTICLES;
  payload: Page<Article>;
}

interface SetArticleAction {
  type: typeof SET_ARTICLE;
  payload: Article;
}

interface SetAuthorsAction {
  type: typeof SET_AUTHORS;
  payload: Author[];
}

interface SetCategoriesAction {
  type: typeof SET_CATEGORIES;
  payload: string[];
}

interface SetSurveysAction {
  type: typeof SET_SURVEYS;
  payload: Page<Survey>;
}

interface SetSurveyAction {
  type: typeof SET_SURVEY;
  payload: Survey;
}

interface SetMetricsAction {
  type: typeof SET_METRICS;
  payload: Page<Metric>;
}

interface SetMetricAction {
  type: typeof SET_METRIC;
  payload: Metric;
}

interface SetExceptionsAction {
  type: typeof SET_EXCEPTIONS;
  payload: Page<Exception>;
}

interface SetExceptionAction {
  type: typeof SET_EXCEPTION;
  payload: Exception;
}

export interface AdminState {
  dashboard: Dashboard;
  articles: {
    currentPage: number;
    list: Page<Article>;
    current?: Article;
  };
  authors: {
    list: Author[];
  };
  categories: {
    list: string[];
  }
  surveys: {
    currentPage: number;
    list: Page<Survey>;
    current?: Survey;
  }
  metrics: {
    currentPage: number;
    list: Page<Metric>;
    current?: Metric;
  }
  exceptions: {
    currentPage: number;
    list: Page<Exception>;
    current?: Exception;
  };
}

export type AdminActionTypes = SetDashboardAction | SetArticlesAction | SetArticleAction | SetAuthorsAction | SetCategoriesAction | SetSurveysAction | SetSurveyAction | SetMetricsAction | SetMetricAction | SetExceptionsAction | SetPageAction | SetExceptionAction;
